import { CreateGroupFormSchema } from 'commons/auditionForm';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

// 多言語対応のためスキーマをフック化
export const useCreateGroupSchema = () => {
  const { t } = useTranslationWithLang('auditionForm');

  const schema = CreateGroupFormSchema({
    RequiredMessage: t('Validate_Required'),
    KanaMessage: t('Validate_Kana'),
    PhoneNumberMessage: t('Validate_PhoneNumber'),
    MinLengthMessage: (min: number) => t('Validate_MinLength', { min }),
    MaxLengthMessage: (max: number) => t('Validate_MaxLength', { max }),
    FullWidthMessage: t('Validate_FullWidth'),
  });
  return schema;
};
